import React, { useEffect, useState } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { StaticKv } from "../components/StaticKv";
import { fetch } from "../utils/api";

import "../assets/styles/company.scss";

export const Company = () => {
  const [certification, setCertification] = useState<[]>();

  useEffect(() => {
    (async () => {
      const certification = await fetch({
        category: "certification",
        filter: "per_page=100",
      });
      setCertification(certification.data);
    })();
  }, []);

  return (
    <div className="page-company">
      <Header>
        <StaticKv title="company" />
      </Header>
      <div className="company-main">
        <h3>保有資格一覧</h3>
        <ul className="card-list certification-list">
          {certification &&
            certification.map((item: any, index) => {
              return (
                <li
                  key={index}
                  dangerouslySetInnerHTML={{ __html: item.content.rendered }}
                ></li>
              );
            })}
        </ul>
        <h3>企業情報</h3>
        <table>
          <tbody>
            <tr>
              <td>社名</td>
              <td>ドリミット株式会社</td>
            </tr>
            <tr>
              <td>代表者</td>
              <td>代表取締役 片波健太郎</td>
            </tr>
            <tr>
              <td>本社</td>
              <td>
                〒150-0011
                <br />
                東京都渋谷区東2丁目17-9 JP-BASE渋谷4F
              </td>
            </tr>
            <tr>
              <td>TEL</td>
              <td>03-5817-4752</td>
            </tr>
            <tr>
              <td>FAX</td>
              <td>03-5817-4753</td>
            </tr>
            <tr>
              <td>設立</td>
              <td>2022年7月8日</td>
            </tr>
            <tr>
              <td>宅地建物取引業</td>
              <td>免許番号 東京都知事（1) 第109537号</td>
            </tr>
          </tbody>
        </table>
        <h3>顧問</h3>
        <ul className="card-list">
          <li>
            <p className="name">司法書士法人五番町法務事務所</p>
            <p>東京都千代田区麹町一丁目5番20号 麹町コルソコモビル5F</p>
          </li>
          <li>
            <p className="name">さくら中央税理士法人</p>
            <p>東京都中央区日本橋人形町2丁目15-15 新扇堂ビル3階</p>
          </li>
          <li>
            <p className="name">弁護士法人プロテクトスタンス</p>
            <p>東京都千代田区有楽町2-10-1 交通会館10F</p>
          </li>
        </ul>
      </div>
      <Footer />
    </div>
  );
};
